module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("费用信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "赛事综合服务费",
      "value": _vm.row.order.memberprice
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "食宿费",
      "value": _vm.row.order.shisuprice
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "其他服务费",
      "value": _vm.row.order.otherprice
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "费用总计",
      "value": _vm.row.order.total
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定提交")])], 1)], 1), _vm._v(" "), (_vm.row.saiqu > 0) ? _c('van-action-sheet', {
    attrs: {
      "actions": (_vm.row.third_pay_info) ? _vm.payActions2 : _vm.payActions
    },
    on: {
      "select": _vm.onPaySelect
    },
    model: {
      value: (_vm.payShow),
      callback: function($$v) {
        _vm.payShow = $$v
      },
      expression: "payShow"
    }
  }) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "请线下汇款",
      "show-cancel-button": "",
      "confirm-button-text": "我已支付，上传凭证"
    },
    on: {
      "confirm": _vm.beizhu
    },
    model: {
      value: (_vm.payOffShow),
      callback: function($$v) {
        _vm.payOffShow = $$v
      },
      expression: "payOffShow"
    }
  }, [(_vm.row.third_pay_img || _vm.row.third_pay_info) ? _c('div', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.third_pay_img),
      expression: "row.third_pay_img"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": _vm.row.third_pay_img
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadpicUrl(_vm.row.third_pay_img)
      }
    }
  }, [_vm._v("下载图片")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "line-height": "30px",
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.row.third_pay_info)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.br2nl(_vm.row.third_pay_info)),
      expression: "br2nl(row.third_pay_info)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("复制文本")])], 1)]) : ((_vm.row.saiqu == 515 || _vm.row.saiqu == 655 || _vm.row.saiqu == 654)) ? _c('div', [_c('p', {
    staticStyle: {
      "text-align": "left",
      "line-height": "30px",
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.shisu_pay_info)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.br2nl(_vm.shisu_pay_info)),
      expression: "br2nl(shisu_pay_info)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("复制文本")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "line-height": "30px",
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fuwu_pay_info)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.br2nl(_vm.fuwu_pay_info)),
      expression: "br2nl(fuwu_pay_info)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("复制文本")])], 1)]) : ((_vm.row.saiqu == 656)) ? _c('div', [_c('p', {
    staticStyle: {
      "text-align": "left",
      "line-height": "30px",
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.zibo_pay_info)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.br2nl(_vm.zibo_pay_info)),
      expression: "br2nl(zibo_pay_info)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("复制文本")])], 1)]) : _c('div', [_c('p', {
    staticStyle: {
      "text-align": "left",
      "line-height": "30px",
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.row.sai_pay_info)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.br2nl(_vm.row.sai_pay_info)),
      expression: "br2nl(row.sai_pay_info)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("复制文本")])], 1)])]), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "scene": "sai_baoming",
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04955375","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep5.vue
// module id = 2178
// module chunks = 0